import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import TypographyBasic from '../Typography/TypographyBasic';
import ConfigConsumer from '../ConfigConsumer';

var Title = function Title(_ref) {
  var id = _ref.id,
      level = _ref.level,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      color = _ref.color,
      strong = _ref.strong,
      semantic = _ref.semantic,
      sign = _ref.sign,
      ellipsis = _ref.ellipsis,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    titleLevel: level
  }, function (_ref2) {
    var _ref2$titleLevel = _ref2.titleLevel,
        titleLevel = _ref2$titleLevel === void 0 ? 1 : _ref2$titleLevel;
    var TagName = "h".concat(titleLevel);
    return /*#__PURE__*/React.createElement(TypographyBasic, {
      className: className,
      style: style,
      color: color,
      strong: strong,
      semantic: semantic,
      sign: sign,
      ellipsis: ellipsis,
      theme: theme
    }, /*#__PURE__*/React.createElement(TagName, {
      "data-outline": "Title",
      id: id,
      className: classNames('jmtd-typography-title', TagName)
    }, children));
  });
};

Title.propTypes = _objectSpread({
  level: PropTypes.number,
  // 1、2、3、4、5、6
  children: PropTypes.any
}, TypographyBasic.propTypes);
Title.defaultProps = _objectSpread({
  level: null,
  children: ''
}, TypographyBasic.defaultProps);
export default Title;